import { render, staticRenderFns } from "./PresetSelectorDialog.vue?vue&type=template&id=17166c68&scoped=true"
import script from "./PresetSelectorDialog.vue?vue&type=script&lang=ts"
export * from "./PresetSelectorDialog.vue?vue&type=script&lang=ts"
import style0 from "./PresetSelectorDialog.vue?vue&type=style&index=0&id=17166c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17166c68",
  null
  
)

export default component.exports